export function getView(has_unrealized_invoices) {
  return has_unrealized_invoices ? 'Content' : 'Empty'
}
